import React, { useState, useEffect } from 'react';
import { apiRequest } from "../services/api";
import { useParams, useLocation } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { Link } from 'react-router-dom';

const staticShipDetails = {
    '1': {
        name: 'Symphony of the Seas',
        details: {
            'Maiden Voyage': '2010',
            'Last Refurbished': '2018',
            'Gross Tonnage': '92,600',
            'Beam': '108 ft (32.9 m)',
            'Maximum Speed': '23 knots',
            'Ship Length': '965 ft (294.1 m)',
            'Passenger Capacity': '2,826',
            'Number of Crew': '934',
            "Crew Nationality": 'International',
            "Officer's Nationality": 'Italian',
            'Number of Decks': '12',
            'Elevators': '12',
            'Number of Staterooms': '1,130',
            'Number of Suites': '216',
            'Dining / Restaurants': '5',
            'Bars / Lounges': '12'
        }
    },
    '2': {
        name: 'Harmony of the Seas',
        details: {
            'Maiden Voyage': '2016',
            'Last Refurbished': '2022',
            'Gross Tonnage': '226,000',
            'Beam': '154 ft (47 m)',
            'Maximum Speed': '22 knots',
            'Ship Length': '1,188 ft (362.1 m)',
            'Passenger Capacity': '5,479',
            'Number of Crew': '2,100',
            "Crew Nationality": 'International',
            "Officer's Nationality": 'Italian',
            'Number of Decks': '16',
            'Elevators': '24',
            'Number of Staterooms': '2,700',
            'Number of Suites': '300',
            'Dining / Restaurants': '10',
            'Bars / Lounges': '18'
        }
    },
    // Add more ships as needed
};

const ShipDetails = () => {
    const { shipId } = useParams();
    const { state: id } = useLocation();
    const [data, setData] = useState([]);
    const [shipLine, setShipLine] = useState([]);
    const [cruiseLine, setCruiseLine] = useState([]);



    useEffect(() => {
        if (id) {
            apiRequest({ url: `/ship-details/${id}` })
                .then((res) => {
                    if (res.success) {
                        setData(res.data);
                        setShipLine(res.ship_name);
                        setCruiseLine(res.cruise_line_name);
                    } else {
                        console.warn("Unexpected response format:", res);
                    }
                })
                .catch((err) => {
                    console.error("Error loading hero slides:", err.message);
                });
        }
    }, [id]);


    // const ship = staticShipDetails[shipId];

    // if (!ship) {
    //     return (
    //         <div className="container text-center mt-5">
    //             <h5>Ship not found.</h5>
    //         </div>
    //     );
    // }

    return (
        <>
            <PageHeader
                title="Cruise Lines "
                image="../../img/cruise.jpg" // use your own path
                breadcrumbs={[
                    { label: "Cruise Lines", active: true },
                    { label: cruiseLine.name, active: true },
                    { label: shipLine, active: true },
                ]}
            />

            <div className="container py-5">
                <div className="mx-auto text-center mb-5" >
                    <h5 className="section-title px-3">{shipLine}</h5>
                </div>
                <div className="card rounded bg-primary mb-3">
                    <div className="card-body ">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item text-white ">
                                <a className='text-white' href="/" data-discover="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                                </a>
                            </li>
                            <li className="breadcrumb-item text-white" aria-current="page">Cruise Lines</li>
                            <li className="breadcrumb-item text-white ">
                                {/* <a className='text-white' href="/cruise/royal-caribbean" data-discover="true">{cruiseLine}</a> */}
                                <Link
                                    to={`/cruise/royal-caribbean`}
                                    state={cruiseLine.id}
                                    className="text-white"
                                >
                                    {cruiseLine.name}
                                </Link>
                            </li>
                            <li className="breadcrumb-item text-white" aria-current="page">{shipLine}</li>
                        </ol>
                    </div>
                </div>
                <div className="card rounded">
                    <div className="card-body p-3 pb-0">
                        {/* <h2 className="mb-4 text-center">{ship.name} - Details</h2> */}

                        <div className="row">
                            {/* {data.map(keyboard, idx) => ( */}
                            {data.map((line, idx) => (
                                <div className="col-md-4 mb-3" key={idx}>
                                    <div className="p-3 border rounded d-flex border-dash">
                                        <span className='text-black-50'>{line.key}:</span>
                                        <strong className='ms-2'>{line.value}</strong>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default ShipDetails;
